import { ClientSideImageUrls } from '../../../../requirejs/ImageUrls'

const placeholderImage = new ClientSideImageUrls('https://meteor.stullercloud.com/').Image

export { placeholderImage }
